import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { USER_ROLE } from '../config/Constants';
import { getToken } from '../utilities/utils';

export function NotFound() {
  const navigate = useNavigate();
  const token = getToken();
  const user = useSelector((state) => state.user);
  const role = user?.role?.id;

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
    if (role) {
      redirectUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, role, token]);

  const redirectUser = () => {
    if (role) {
      switch (role) {
        case USER_ROLE.ADMIN:
          navigate('/admin/resource');
          break;
        case USER_ROLE.SCHOOL_ADMIN:
          navigate('/school/dashboard');
          break;
        default:
          navigate('/dashboard');
          break;
      }
    }
  };

  return (
    <div className="-alt">
      <div className="container ht-100p tx-center">
        <div className="ht-100p d-flex flex-column align-items-center justify-content-center">
          <h1 className="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">404 Page Not Found</h1>
          <h5 className="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">
            Oopps. The page you were looking for doesn't exist.
          </h5>
          <div className="d-flex mg-b-40">
            <button
              type="button"
              onClick={() => {
                redirectUser();
              }}
              className="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25"
            >
              Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
